import React from 'react'
import styled from 'styled-components'
import TranslateText from 'src/text/modal';


const Tab = styled.div`
  cursor: pointer;
  margin-right: 25px;
  margin-top: 10px;
  ${props => props.selected ? 'color: rgb(23, 61, 176); font-weight: 800;' : 'border-bottom: 2px solid rgb(210, 215, 218);'}
`

function Desktop({cards, selected, setSelected}) {
  return (
    <div
      style={{
        display: 'flex',
        flexWrap: 'wrap',
        marginBottom: 20,
      }}
    >
      {
        (['Все', ...(cards ? Object.keys(cards) : [])]).map((c, i) => {
          return (
            <Tab
              onClick={() => {
                setSelected(c)
              }}
              selected={selected == c}
            >
              {c === 'Все' ?
                <TranslateText
                  id="search_tabs__all"
                  place="bottom"
                  style={{ display: 'inline' }}
                />
                :
                c
              }
              <span style={{...(selected != c && {color: 'rgb(210, 215, 218)'})}}>
                {
                  i === 0
                    ? ` (${(cards ? Object.keys(cards) : []).reduce((r, e) => r + cards[e].length, 0)})`
                    : ` (${cards[c].length})`
                }
              </span>
            </Tab>
          )
        })
      }
    </div>
  )
}

export default Desktop



// WEBPACK FOOTER //
// ./src/finwhale/common/search/category-type/Desktop.js